var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconContactX = function SvgIconContactX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    x: 1,
    y: 1.1,
    stroke: "#A36E21",
    rx: 3.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_contact_x_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A36E21",
    d: "M28.786 24.764 37.722 14.6h-2.117l-7.763 8.823-6.195-8.823H14.5l9.37 13.343L14.5 38.6h2.117l8.192-9.32 6.544 9.32H38.5M17.38 16.162h3.253l14.97 20.953H32.35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_contact_x_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.5 14.6h24v24h-24z"
  })))));
};
export default SvgIconContactX;